export function visualHeapSort(array){
  let animations = []; //[type, [i,j,k], [arr[i,j,k]], reads, writes] 0=read, 1=write 2=read in same sequence, no update color or prev
  let len = array.length;
  let reads = 0;
  let writes = 0;


  function arr2heap(arr, len, i, animations){
    let largest = i;
    let left = i*2 + 1;
    let right = left + 1;

    reads += 1;
    let indexes = [i];
    let heights = [arr[i]];

    if (left < len && arr[left] > arr[largest]){
      largest = left;
      reads += 1;
      indexes.push(left);
      heights.push(arr[left]);
    }

    if (right < len && arr[right] > arr[largest]){
      largest = right;
      reads += 1;
      indexes.push(right);
      heights.push(arr[right]);
    }

    animations.push([0, indexes, heights, reads, writes]);

    if (largest != i) {
      animations.push([1, [i,largest], [arr[i],arr[largest]], reads, writes]);

      [arr[largest], arr[i]] = [arr[i], arr[largest]];
      writes += 2

      animations.push([1, [i,largest], [arr[i],arr[largest]], reads, writes]);
      animations.push([2, [i,largest], [arr[i],arr[largest]], reads, writes]);

      arr2heap(arr, len, largest, animations, reads, writes);
    }

    return arr;
  }



  let i = Math.floor(len/2 - 1); //last parent node, halfway-1
  let k = len - 1; // last child

  while (i>=0){
    arr2heap(array, len, i, animations, reads, writes);
    i--;
  }

  while (k >= 0){
    reads += 2;
    writes += 2;
    animations.push([0, [0,k], [array[0],array[k]], reads, writes]);
    animations.push([1, [0,k], [array[0],array[k]], reads, writes]);
    [array[0],array[k]] = [array[k],array[0]];
    animations.push([1, [0,k], [array[0],array[k]], reads, writes]);
    animations.push([0, [0,k], [array[0],array[k]], reads, writes]);

    arr2heap(array, k, 0, animations);
    k--;
  }

  return animations;
}
